import { SelectBox } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Button,
    Card,
    Collapse,
    Form,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'sweetalert2/src/sweetalert2.scss';
import { useAuth } from '../../auth';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';
import { getTaseron } from '../../services/getTaseron';
import useFormatMessage from '../../utils/useFormatMessage';

const MobileGroupageForm = () => {
    const { t } = useFormatMessage()
    const [warehouses, setWarehouses] = useState([]);
    const [cities, setCities] = useState([]);
    const [contractors, setContractors] = useState([]);
    const [chassisList, setChassisList] = useState([]);
    const [open, setIsOpen] = useState(false);
    const [barcodeInput, setBarcodeInput] = useState('');
    const { hasRole } = useAuth(7);
    const [isLoading, setIsLoading] = useState(false);
    const [truckDetails, setTruckDetails] = useState({
        driver_name: '',
        driver_phone: '',
        plate_number: '',
        trailer_plate: '',
        subcontractor_id: null
    });

    useEffect(() => {
        fetchWarehouses();
        fetchCities();
        fetchContractors();
    }, [])

    useEffect(() => {
        // Barkod okuyucu için event listener
        let barcodeTimeout;
        const handleKeyDown = (event) => {
            // Eğer bir input alanı aktif değilse veya aktif alan şase input alanı ise
            if (document.activeElement.tagName !== 'INPUT' || document.activeElement.id === 'chassis') {
                // Enter tuşu için özel işlem
                if (event.key === 'Enter') {
                    if (barcodeInput) {
                        // Şase numarası 17 haneli mi kontrol et
                        if (barcodeInput.length === 17) {
                            const chassisInput = document.getElementById('chassis');
                            if (chassisInput) {
                                chassisInput.value = barcodeInput;
                                handleAddChassis();
                            }
                        } else {
                            toast.error("Geçersiz şase numarası - 17 haneli olmalıdır");
                        }
                        setBarcodeInput('');
                    }
                    event.preventDefault();
                } else if (event.key.length === 1) { // Sadece yazdırılabilir karakterler
                    // Timeout'u temizle ve yeni bir timeout başlat
                    clearTimeout(barcodeTimeout);
                    setBarcodeInput(prev => {
                        const newValue = prev + event.key;
                        // Eğer 17 karaktere ulaştıysa otomatik olarak handleAddChassis'i tetikle
                        if (newValue.length === 17) {
                            const chassisInput = document.getElementById('chassis');
                            if (chassisInput) {
                                chassisInput.value = newValue;
                                // Kısa bir gecikme ile handleAddChassis'i çağır
                                setTimeout(() => {
                                    handleAddChassis();
                                    setBarcodeInput('');
                                }, 100);
                            }
                        }
                        return newValue;
                    });

                    // 1 saniye sonra barcodeInput'u sıfırla
                    barcodeTimeout = setTimeout(() => {
                        setBarcodeInput('');
                    }, 1000);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Cleanup
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            clearTimeout(barcodeTimeout);
        };
    }, [barcodeInput]); // barcodeInput değişikliklerini izle

    const fetchWarehouses = async () => {
        try {
            const res = await getAllWarehouses();
            setWarehouses(res);
        } catch (err) {
            toast.error("Depo Listesi Alınırken hata oluştu");
        }
    };

    const fetchCities = async () => {
        try {
            const response = await api.post("/city/getAll");
            setCities(response.data.data?.filter((item) => item.is_active && item.id !== 7) || []);
        } catch (error) {
            toast.error("Şehir listesi alınamadı");
        }
    };

    const fetchContractors = async () => {
        (async () => {
            const taseronlar = await getTaseron({ transport_company: true });
            setContractors(taseronlar);
        })();
    };

    const handleAddChassis = async () => {
        const chassisInput = document.getElementById('chassis');
        const chassisValue = chassisInput?.value?.trim();

        if (!chassisValue) {
            toast.error("Lütfen şase numarası giriniz");
            return;
        }

        // Check duplicates
        if (chassisList?.some(c => c?.chassis_no === chassisValue)) {
            toast.error("Bu şase numarası zaten ekli");
            return;
        }

        try {
            const response = await api.post("/checkValidityForCustomGroupage", {
                chassis_no: chassisValue
            });

            const chassisData = response.data;

            if (!chassisData.is_valid) {
                toast.error("Bu şase grupaja uygun değil");
                return;
            }

            // Check if contractor matches with existing chassis
            if (chassisList.length > 0 && chassisList[0].contractor !== chassisData.contractor) {

                let contractorName = chassisData.contractor
                toast.error("Bu şasenin kontrat sahibi diğer şaselerden farklı: " + contractorName, {
                    autoClose: 10000
                });
                return;
            }

            setChassisList(prevList => [...prevList, {
                chassis_no: chassisValue,
                contractor: chassisData.contractor,
                model: chassisData.model,
                color: chassisData.color
            }]);

            if (chassisInput) {
                chassisInput.value = '';
            }

        } catch (error) {
            let error_msj = error.response?.data?.error || null;
            error_msj = t(error_msj.split(":")[0]) + (error_msj.split(":")[1])
            toast.error(error_msj || "Şase kontrolü sırasında hata oluştu");
        }
    };

    const validateForm = () => {
        if (chassisList.length === 0) {
            toast.error("Şase numarası eklemelisiniz");
            return false;
        }

        const warehouseId = document.getElementById("depolar-select").childNodes[0].childNodes[0].value;
        const cityId = document.getElementById("city-select").childNodes[0].childNodes[0].value;

        if (!warehouseId) {
            toast.error("Depo seçmelisiniz");
            return false;
        }

        if (!cityId) {
            toast.error("Şehir seçmelisiniz");
            return false;
        }

        if (!truckDetails.driver_name) {
            toast.error("Şoför adı boş olamaz");
            return false;
        }

        // Phone number format validation (optional but must be valid if provided)
        if (truckDetails.driver_phone.length > 0) {
            const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/
            if (!phoneRegex.test(truckDetails.driver_phone)) {
                toast.error('10 Haneli bir telefon numarası giriniz. Örn: 5XXXXXXXXX')
                return false
            }
        }

        if (!truckDetails.plate_number) {
            toast.error("Plaka boş olamaz");
            return false;
        }

        // License plate format validation (2 numbers + any letters + any numbers)
        const plateRegex = /^[0-9]{2}[A-Z]+[0-9]+$/
        if (!plateRegex.test(truckDetails.plate_number)) {
            toast.error('Geçerli bir plaka formatı giriniz. Örn: 34ABC123')
            return false
        }

        if (!truckDetails.subcontractor_id) {
            toast.error("Taşıyıcı firma boş olamaz");
            return false;
        }

        return true;
    };

    const handleConfirm = async () => {
        if (isLoading) return;

        if (!validateForm()) {
            return;
        }

        const selectedWarehouseId = document.getElementById("depolar-select").childNodes[0].childNodes[0].value;

        try {
            setIsLoading(true);

            const requestBody = {
                chassis_numbers: chassisList.map(c => c.chassis_no),
                city_id: parseInt(document.getElementById("city-select").childNodes[0].childNodes[0].value),
                contractor_id: parseInt(truckDetails.subcontractor_id),
                truck_info: {
                    driver_name: truckDetails.driver_name,
                    driver_phone: truckDetails.driver_phone,
                    plate_number: truckDetails.plate_number,
                    groupage_no: "string",
                    subcontractor_id: parseInt(truckDetails.subcontractor_id),
                    trailer_plate: truckDetails.trailer_plate,
                },
                warehouse_id: parseInt(selectedWarehouseId)
            };
            const response = await api.post("/createCustomGroupage", requestBody);

            if (response.status === 200) {
                toast.success("Grupaj ve tır eşleme işlemi başarıyla tamamlandı");
                // Reset form
                setChassisList([]);
                setTruckDetails({
                    driver_name: '',
                    driver_phone: '',
                    plate_number: '',
                    trailer_plate: '',
                    subcontractor_id: null
                });
            }
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.error || "İşlem sırasında hata oluştu");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Breadcrumb current={t("Grupaj / Tır Eşleme")} />


            <Card className="mobile-form-card p-3">
                <div className="row">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <Form>
                            <div className="main-form">
                                <FormGroup className="mb-2">
                                    <Label className="form-label-sm">Nereden</Label>
                                    <SelectBox
                                        id='depolar-select'
                                        placeholder="Depo Seçiniz"
                                        dataSource={warehouses}
                                        defaultValue={localStorage.getItem("warehouse") ? parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii')) : null}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        className="w-100"
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <Label className="form-label-sm">Nereye</Label>
                                    <SelectBox
                                        id='city-select'
                                        placeholder="İl Seçiniz"
                                        dataSource={cities}
                                        displayExpr="city_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        className="w-100"
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <Label className="form-label-sm">Taşıyıcı Firma</Label>
                                    <SelectBox
                                        value={truckDetails.subcontractor_id}
                                        placeholder="Taşıyıcı Firma Seçiniz"
                                        dataSource={contractors}
                                        displayExpr="name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        className="w-100"
                                        onValueChanged={(e) => setTruckDetails(prev => ({
                                            ...prev,
                                            subcontractor_id: e.value
                                        }))}
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <Label className="form-label-sm">Şoför Bilgileri</Label>
                                    <Input
                                        className="mb-1"
                                        value={truckDetails.driver_name}
                                        onChange={(e) => {
                                            // Only allow letters, spaces, and Turkish characters
                                            const cleaned = e.target.value.replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '')
                                            setTruckDetails(prev => ({
                                                ...prev,
                                                driver_name: cleaned
                                            }))
                                        }}
                                        placeholder="Şoför Adı"
                                        type="text"
                                        autoComplete="name"
                                        name="sofor-adi"
                                        form="truck-form"
                                    />
                                    <Input
                                        value={truckDetails.driver_phone}
                                        onChange={(e) => {
                                            // Only allow numbers and format as phone number
                                            const phoneNumber = e.target.value.replace(/\D/g, '')
                                            if (phoneNumber.length <= 10) {
                                                const formattedPhone = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                setTruckDetails(prev => ({
                                                    ...prev,
                                                    driver_phone: formattedPhone
                                                }))
                                            }
                                        }}
                                        placeholder="Telefon"
                                        type="tel"
                                        autoComplete="tel"
                                        name="sofor-telefon"
                                        form="truck-form"
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <Label className="form-label-sm">Araç Bilgileri</Label>
                                    <div className="d-flex gap-2">
                                        <Input
                                            value={truckDetails.plate_number}
                                            onChange={(e) => {
                                                // Format as Turkish license plate: Number-Letters-Number
                                                const cleaned = e.target.value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
                                                let formatted = ''

                                                if (cleaned.length <= 2) {
                                                    // First part (numbers only)
                                                    const numbers = cleaned.replace(/[^0-9]/g, '')
                                                    formatted = numbers
                                                } else {
                                                    // Split into parts: first 2 numbers, then letters, then remaining numbers
                                                    const firstPart = cleaned.slice(0, 2).replace(/[^0-9]/g, '')
                                                    const remainingPart = cleaned.slice(2)
                                                    const letters = remainingPart.replace(/[^A-Z]/g, '')
                                                    const numbers = remainingPart.replace(/[^0-9]/g, '')

                                                    formatted = firstPart + letters + numbers
                                                }

                                                setTruckDetails(prev => ({
                                                    ...prev,
                                                    plate_number: formatted
                                                }))
                                            }}
                                            placeholder="Tır Plakası"
                                            type="text"
                                            autoComplete="on"
                                            name="plaka"
                                            form="truck-form"
                                        />
                                        <Input
                                            value={truckDetails.trailer_plate}
                                            onChange={(e) => setTruckDetails(prev => ({
                                                ...prev,
                                                trailer_plate: e.target.value.toUpperCase()
                                            }))}
                                            placeholder="Dorse"
                                            type="text"
                                            autoComplete="on"
                                            name="dorse"
                                            form="truck-form"
                                        />
                                    </div>
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label className="form-label-sm">Şase</Label>
                                    <div className="d-flex">
                                        <Input
                                            id="chassis"
                                            placeholder="Şase No Okutunuz"
                                            type="text"
                                            autoComplete='off'
                                            className="form-control-md chassis-input"
                                        />
                                        <Button
                                            color="warning"
                                            className="ms-2 add-chassis-btn ml-1 p-0"
                                            style={{ width: "50px" }}
                                            onClick={handleAddChassis}
                                        >
                                            <i className="fa fa-plus" style={{
                                                fontSize: "large"
                                            }}></i>
                                        </Button>
                                    </div>

                                </FormGroup>

                                <div className="chassis-list-container mb-3">
                                    <div className="chassis-header d-flex justify-content-between align-items-center p-2"
                                        onClick={() => setIsOpen(!open)}>
                                        <div className="d-flex align-items-center">
                                            <i className={`fa fa-chevron-${open ? 'up' : 'down'} me-2`}></i> &nbsp;
                                            <span className="fw-bold">ŞASE LİSTESİ ({chassisList.length})</span>
                                        </div>
                                    </div>
                                    {chassisList.length > 0 && (
                                        <div className="contractor-header p-2 border-bottom">
                                            <span className="text-muted">Kontrat Sahibi: {chassisList[0].contractor}</span>
                                        </div>
                                    )}

                                    <Collapse isOpen={open}>
                                        <div className="chassis-list">
                                            {chassisList.map((chassis) => (
                                                <div key={chassis.chassis_no} className="chassis-item">
                                                    <div className="d-flex align-items-center" style={{ gap: "24px" }}>
                                                        <span className="chassis-no">{chassis.chassis_no}</span>
                                                        <span className="text-muted">{chassis.model}</span>
                                                        <span className="text-muted">{chassis.color}</span>
                                                    </div>
                                                    <button
                                                        className="delete-btn"
                                                        onClick={() => {
                                                            setChassisList(prevList =>
                                                                prevList.filter(item => item.chassis_no !== chassis.chassis_no)
                                                            );
                                                        }}
                                                    >
                                                        <i className="fa fa-times"></i>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </Collapse>
                                </div>
                            </div>

                            {hasRole("grupaj_tir_write_only") && (
                                <Button
                                    color="success"
                                    className="w-100 py-1 mt-1 confirm-button"
                                    onClick={handleConfirm}
                                    disabled={chassisList.length === 0 || isLoading}
                                >
                                    <i className="fa fa-check me-2"></i> &nbsp;
                                    {isLoading ? 'İŞLEM YAPILIYOR...' : 'ONAYLA'}
                                </Button>
                            )}
                        </Form>
                    </div>
                </div>
            </Card>



            <style>
                {`
                    .mobile-form-card {
                        border: none;
                        margin-bottom: 1rem;
                    }

                    .chassis-list-container {
                        border: 1px solid #e9ecef;
                        border-radius: 4px;
                    }

                    .chassis-header {
                        background: #f8f9fa;
                        cursor: pointer;
                        border-bottom: 1px solid #e9ecef;
                    }

                    .chassis-list {
                        max-height: 300px;
                        overflow-y: auto;
                    }

                    .chassis-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 8px 16px;
                        border-bottom: 1px solid #e9ecef;
                        font-size: 0.9rem;
                    }

                    .chassis-item:last-child {
                        border-bottom: none;
                    }

                    .chassis-no {
                        font-weight: 500;
                        min-width: 140px;
                    }

                    .text-muted {
                        min-width: 100px;
                    }

                    .delete-btn {
                        border: none;
                        background: none;
                        color: #dc3545;
                        padding: 4px;
                    }

                    .delete-btn:hover {
                        color: #c82333;
                    }

                    .form-label-sm {
                        font-size: 0.875rem;
                        color: #6c757d;
                        margin-bottom: 0.25rem;
                    }

                    .gap-2 {
                        gap: 0.5rem;
                    }

                    .confirm-button {
                        height: 60px;
                        font-size: 18px;
                        margin-top: 20px !important;
                    }

                    /* Mobil cihazlar için özel stiller */
                    @media (max-width: 768px) {
                        .mobile-form-card {
                            margin: 0;
                            padding: 0.5rem;
                        }

                        .form-control, .dx-texteditor-input {
                            height: 48px !important;
                            font-size: 16px !important;
                            padding: 10px !important;
                        }

                        .chassis-input {
                            height: 50px !important;
                            font-size: 18px !important;
                        }

                        .add-chassis-btn {
                            width: 50px !important;
                            height: 50px !important;
                            padding: 0 !important;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .form-label-sm {
                            font-size: 14px !important;
                            margin-bottom: 4px !important;
                        }

                        .chassis-list {
                            max-height: 150px;
                        }

                        .chassis-item {
                            padding: 12px !important;
                        }

                        .confirm-button {
                            height: 60px;
                            font-size: 18px;
                            margin-top: 20px !important;
                        }

                        /* DevExtreme SelectBox özelleştirmeleri */
                        .dx-texteditor {
                            height: 48px !important;
                        }

                        .dx-texteditor-input {
                            padding: 10px !important;
                        }

                        /* Form grupları arası boşluk */
                        .form-group {
                            margin-bottom: 16px !important;
                        }
                    }
                `}
            </style>
        </>
    );
};

export default MobileGroupageForm;